import { Stream } from "@cloudflare/stream-react";

const LIFE_AND_LEGACY_VIDEOS = [
  {
    title: "Father Paul Oneid Memorial in Arabic",
    titleArabic: "فيلم تأبيني للأب بولس عنيد باللغة العربية",
    language: "Arabic",
    playbackId: "6337b857f2d618c2b43f4ea6a71ac0d9",
  },
  {
    title: "Father Paul Oneid Memorial in English",
    titleArabic: "فيلم تأبيني للأب بولس عنيد باللغة الإنجليزية",
    language: "English",
    playbackId: "e80d9820a6a5ed6bc0a9450e08e56127",
  },
  {
    title: "Father Paul Oneid 100th Birthday",
    titleArabic: "الذكرى المئوية لميلاد الأب بولس عنيد",
    language: "Centennial Celebration",
    playbackId: "7057062adb0baf6e362936bdfe7cb53f",
  },
  {
    title: "Father Paul Oneid Biography in Arabic",
    titleArabic: "سيرة الأب بولس عنيد باللغة العربية",
    language: "Arabic",
    playbackId: "81633ef212c63f40f1b0a9457c100410",
  },
];

export default function AbounaLifeLegacy() {
  return (
    <section className="life-legacy" aria-labelledby="life-legacy-title">
      <div className="live-funeral__heading">
        <span className="live-funeral__cross" aria-hidden="true">✝</span>
        <p className="live-funeral__kicker">A Life of Faith and Service</p>
        <h1 id="life-legacy-title">Abouna: Life &amp; Legacy</h1>
        <p>
          These commemorative films celebrate the life, faith, ministry, and enduring
          legacy of Reverend Father Paul Oneid. Created with love and dedication by his
          nephew, John Saleh, they preserve treasured moments from Abouna’s journey—from
          his life story and centennial celebration to memorial tributes in Arabic and
          English—for family, parishioners, and future generations.
        </p>
        <p className="life-legacy__credit">Created by John Saleh</p>
      </div>

      <div className="life-legacy__grid">
        {LIFE_AND_LEGACY_VIDEOS.map((video, index) => (
          <article className="life-legacy__card" key={video.title}>
            <div className="life-legacy__player">
              <Stream
                controls
                src={video.playbackId}
                responsive
                preload="metadata"
                autoplay={false}
                muted={false}
                loop={false}
                primaryColor="#d9a949"
                letterboxColor="#21151e"
              />
            </div>
            <div className="life-legacy__card-copy">
              <span className="life-legacy__number" aria-hidden="true">
                {String(index + 1).padStart(2, "0")}
              </span>
              <div>
                <p>{video.language}</p>
                <h2>{video.title}</h2>
                <h3 className="life-legacy__title-arabic" lang="ar" dir="rtl">
                  {video.titleArabic}
                </h3>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
